import React from 'react';
import Pagination from '../Common/Pagination';

const TestHistoryList = ({
  tests,
  selectedTestId,
  onSelect,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getStatusBadge = (status) => {
    const badges = {
      completed: { class: 'badge-success', text: '✓' },
      failed: { class: 'badge-error', text: '✗' },
      running: { class: 'badge-warning', text: '⟳' },
      pending: { class: 'badge-info', text: '⋯' },
    };
    return badges[status] || badges.pending;
  };

  if (tests.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 20px' }}>
        <p style={{ color: 'var(--text-secondary)' }}>No tests found</p>
      </div>
    );
  }

  return (
    <>
      <div style={styles.testsList}>
        {tests.map((test) => {
          const isSelected = test._id === selectedTestId;
          const badge = getStatusBadge(test.status);

          return (
            <div
              key={test._id}
              style={{
                ...styles.testItem,
                ...(isSelected ? styles.testItemSelected : {}),
              }}
              onClick={() => onSelect(test)}
            >
              <div style={styles.testItemHeader}>
                <span className={`badge ${badge.class}`} style={{ fontSize: '10px' }}>
                  {badge.text}
                </span>
                <span style={styles.testDate}>{formatDate(test.createdAt)}</span>
              </div>

              {test.status === 'completed' && test.results && (
                <div style={styles.testItemStats}>
                  <div style={styles.statItem}>
                    <span style={styles.statLabel}>Requests:</span>
                    <span style={styles.statValue}>{test.results.totalRequests}</span>
                  </div>
                  <div style={styles.statItem}>
                    <span style={styles.statLabel}>Avg Time:</span>
                    <span style={styles.statValue}>
                      {Math.round(test.results.averageResponseTime)}ms
                    </span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {totalPages > 1 && (
        <div style={{ marginTop: '20px' }}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </>
  );
};

const styles = {
  testsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  testItem: {
    padding: '15px',
    background: 'var(--light-gray)',
    border: '2px solid var(--border-color)',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  testItemSelected: {
    borderColor: 'var(--primary-black)',
    background: 'rgba(0, 0, 0, 0.04)',
  },
  testItemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  testDate: {
    fontSize: '12px',
    color: 'var(--text-secondary)',
  },
  testItemStats: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    paddingTop: '10px',
    borderTop: '1px solid var(--border-color)',
  },
  statItem: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '12px',
  },
  statLabel: {
    color: 'var(--text-secondary)',
  },
  statValue: {
    color: 'var(--text-primary)',
    fontWeight: '600',
  },
};

export default TestHistoryList;

